import classNames from 'classnames';
import React from 'react';

import { SuperEllipseSize } from '@xingternal/super-ellipse';
import { Headline } from '@xingternal/typography';
import { Column, Row } from '@xingternal/xing-grid';

import { CompanyLogo, CompanyLogoWithLink } from '@/components/company-logo';
import { ActionsContainer } from '@/components/posting-header-actions';
import { JobPostingVisibleJobFragment } from '@/graphql/generated';
import { appendQueryParams } from '@/helpers/query-string';
import { redirectUrl } from '@/helpers/redirect-url';

import styles from '../../body.css';
import lineClamp from '@/utils/line-clamp.css';

type Props = {
  companyProfileUrl?: string;
  logoSize?: SuperEllipseSize;
  job: JobPostingVisibleJobFragment;
};

export const FixedBody: React.VFC<Props> = ({ companyProfileUrl, logoSize, job }) => {
  const logo = job.companyInfo?.company?.logo?.url || undefined;
  const urlWithTracking =
    companyProfileUrl &&
    appendQueryParams(companyProfileUrl, {
      sc_o: 'jobs_header_company_logo_name_click',
    });
  const handleClick = (event): void => {
    if (!urlWithTracking) return;
    redirectUrl(event, urlWithTracking);
  };

  return (
    <Row className={classNames(styles.module, styles.fixedModule)}>
      <Column size={12} className={styles.verticalAlign}>
        {companyProfileUrl ? (
          <CompanyLogoWithLink
            url={companyProfileUrl}
            onClick={handleClick}
            {...(logoSize && { size: logoSize })}
            name={job.companyInfo.companyNameOverride}
            src={logo}
            className={classNames(styles.fixedCompanyLogo, styles.logo)}
          />
        ) : (
          <CompanyLogo
            {...(logoSize && { size: logoSize })}
            name={job.companyInfo.companyNameOverride}
            src={logo}
            className={classNames(styles.fixedCompanyLogo, styles.logo)}
          />
        )}

        <Headline className={styles.title} level="xlarge" as="h1">
          <div className={lineClamp.lineClamp2}>{job.title}</div>
        </Headline>
        <ActionsContainer isSticky={true} />
      </Column>
    </Row>
  );
};
